export default __webpack_public_path__ + "static/media/flame_line_top_pc.ec69c757.svg";